import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

import pittogramma from "../assets/figma/footer-mark.svg";

import "../css/Footer.css";

function Footer() {
  const { t } = useTranslation();

  const legalFiles = useMemo(
    () => [
      t("main.aboutUs.downloads.companyData"),
      t("main.aboutUs.downloads.informationMemorandum"),
      t("main.aboutUs.downloads.inclusionDocument"),
      t("main.aboutUs.downloads.ethicalCode"),
      t("main.aboutUs.downloads.model231_5"),
    ],
    [t]
  );

  return (
    <>
      <section className="footer-social">
        <div className="footer-social-inner">
          <span>{t("main.footer.followUs")}</span>

          <a
            href="https://www.linkedin.com/company/rigsave/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>


        </div>
      </section>

      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-top">
            <div className="footer-col">
              <h4>{t("main.footer.company")}</h4>
              <Link to="/">{t("main.header.home")}</Link>
              <Link to="/about-us">{t("main.header.aboutUs")}</Link>
              <Link to="/services">{t("main.header.services")}</Link>
            </div>

            <div className="footer-col">
              <h4>{t("main.footer.investorRelations")}</h4>

              <Link to="/director-dealings">
                {t("main.header.servicesDropdown.directorDealings")}
              </Link>

              <Link to="/analyst-reports">
                {t("main.header.servicesDropdown.analystReports")}
              </Link>

              <Link to="/financial-calendar">
                {t("main.header.servicesDropdown.financialCalendar")}
              </Link>

              <Link to="/corporate-actions">
                {t("main.header.servicesDropdown.corporateActions")}
              </Link>

              <Link to="/financial-reports">
                {t("main.header.servicesDropdown.financialReports")}
              </Link>
              <Link to="/shareholders-meetings">{t("main.header.shareholdersMeetings")}</Link>
            </div>

            <div className="footer-col">
              <h4>{t("main.footer.legalCompliance")}</h4>

              {legalFiles.map((name) => (
                <Link key={name} to="/about-us#download-list">
                  {name}
                </Link>
              ))}
            </div>

            <div className="footer-col footer-contacts">
              <h4>{t("main.header.contacts")}</h4>

              <a href="mailto:info@rigsave.com">info@rigsave.com</a>

              <a href="tel:+393392246507">(+39) 3392246507</a>

              <a
                href="https://www.google.com/maps?q=Corso+Giuseppe+Zanardelli+38,+Brescia,+Italia"
                target="_blank"
                rel="noopener noreferrer"
              >
                C.so Giuseppe Zanardelli 38,
                <br />
                Brescia (BS)
              </a>
            </div>

            <div className="footer-logo">
              <img src={pittogramma} alt="Rigsave logo" />
            </div>
          </div>

          <div className="footer-divider" />

          <div className="footer-bottom">
            <div className="footer-company">
              <h4>Rigsave S.p.A.</h4>

              <p>{t("main.footer.companyDescription")}</p>


              <p>
                {t("main.footer.operationalOffice2")}
              </p>
            </div>

            <div className="footer-legal">
              <a
                href="https://www.iubenda.com/privacy-policy/32717822"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("main.footer.privacy")}
              </a>

              <a
                href="https://www.iubenda.com/privacy-policy/32717822/cookie-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("main.footer.cookies")}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;